import api from '../../helpers/axios'

export const state = {
    product: null,
    products: [],
    productTransaction: null,
    productTransactions: null,
};

export const getters = {
    product: (state) => state.product,
    products: (state) => state.products,
    productTransaction: (state) => state.productTransaction,
    productTransactions: (state) => state.productTransactions
};

export const mutations = {
    setProduct(state, newValue) {
        state.product = newValue;
    },
    setProducts(state, newValue) {
        state.products = newValue;
    },
    setProductTransaction(state, newValue) {
        state.productTransaction = newValue;
    },
    setProductTransactions(state, newValue) {
        state.productTransactions = newValue;
    },
};

export const actions = {
    createProduct(_,  data) {
        return new Promise((resolve) => {
            api.post("/products", data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    updateProduct(_, {id,data}) {
        return new Promise((resolve) => {
            api.put("/products/"+id, data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    deleteProduct(_, id) {
        return new Promise((resolve) => {
            api.delete("/products/"+id).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchProduct({ commit }, {id}) {
        return new Promise((resolve,reject) => {
            api.get("/products/"+id).then((res) => {
                commit("setProduct", res.data.data);
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },
    fetchProducts({ commit }, {page, limit, search, listType}) {
        let query = "?";
        if(listType){
            query+=`listType=${listType}`
        }else{
            if (search) {
                query += `name=${search}&`;
            }
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }
        return new Promise((resolve) => {
            api.get("/products"+query).then((res) => {
                commit("setProducts", res.data.data);
                resolve(res.data.data)
            })
        });
    },
    createProductTransaction(_,  {productId,data}) {
        return new Promise((resolve) => {
            api.post("/products/"+productId+"/transactions", data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchProductTransactions({ commit }, {productId,...params}) {
        return new Promise((resolve) => {
            api.get("/products/"+productId+"/transactions", {params: {...params}}).then((res) => {
                commit("setProductTransactions", res.data.data);
                resolve(res.data.data)
            })
        });
    },
};
